import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import { NormativeService } from './normative.service';

@Component({
  selector: 'app-normative',
  templateUrl: './normative.component.html',
  styleUrls: ['./normative.component.scss']
})
export class NormativeComponent implements OnInit {

  /**
   * Se debe agregar en contants y en el lang.ts, s eencuentran con este nombre NORMATIVE_TITTLE_# 
   */
  normativesPdf = []
  constructor(
    private normativeService: NormativeService,
    public LANG: CommonUtilitiesService
  ) { }

  ngOnInit() {
    this.normativeService.getAllNormative().subscribe((dataInfo => {
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.normativesPdf = dataInfo['obj'].map(obj => {
          let newObj: any = new Object();
          newObj.file = obj.documentLink;
          newObj.title = obj.title;
          return newObj;
        });
      } else {
        alert("No se ha podido establecer la conexión con el servidor.");
      }
    }),
      (err) => {
        alert("No se ha podido establecer la conexión con el servidor.");
      });
  }

  openPdf(file) {
    window.open(file);
  }
}
